var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArtisanGrid',{attrs:{"metaData":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }